import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAll() {
        const res = await http.get(buildUrlFromLocation("/orders"));
        return res.data;
    },
    async getAllWithLimit(limit) {
        const res = await http.get(buildUrlFromLocation("/orders?limit=" + limit));
        return res.data;
    }
};



// WEBPACK FOOTER //
// ./src/services/order.js